import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Col, Row, Typography } from 'antd';
import ControlledSliderField from '../form-helpers/ControlledSliderField';

const { Title } = Typography;

const styles = {
  col: {
    display: 'flex',
  },
  question: {
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.02em",
    color: "#8C8C8C",
    marginBottom: 25,
    marginTop: 50
  }
};

function MobileSliderQuestion({
  question,
  fieldName,
  sliderMinValue,
  sliderMaxValue,
  svgIcon: SvgIcon,
  bodyStyle,
  labelSlider
}) {
  const { t } = useTranslation();
  return (
    <Box {...bodyStyle}>
      {SvgIcon && (
        <Row justify="center">
          <Col style={styles.col}>
            <SvgIcon />
          </Col>
        </Row>
      )}
      {
        question.length > 0 && (
          <Title level={4} style={styles.question}>
            {t(`${question}`)}
          </Title>
        )
      }
      <Box maxWidth="80%" marginY={0} marginX="auto">
        <ControlledSliderField
          name={fieldName}
          label={labelSlider}
          min={sliderMinValue}
          max={sliderMaxValue}
        />
      </Box>
    </Box>
  );
}

MobileSliderQuestion.defaultProps = {
  question: '',
  bodyStyle: {},
  labelSlider: ''
};

const { string, number, shape, func } = PropTypes;

MobileSliderQuestion.propTypes = {
  question: string,
  fieldName: string.isRequired,
  sliderMinValue: number,
  sliderMaxValue: number,
  svgIcon: func,
  labelSlider: string,
  bodyStyle: shape({})
};

export default MobileSliderQuestion;
